import { isServer } from '@app/utils';
import type { GraphQLClient } from 'graphql-request';

import browser from './client.browser';
import server from './client.server';
import type { clientOptions } from './types';

/**
 *
 * @param options
 */
const client = (options: clientOptions = {}): GraphQLClient => {
  if (isServer) {
    return server(options);
  }

  // Browser gets all data from DOM, so no need to attach anything special
  return browser(options);
};

export default client;
